import { Routes } from '@angular/router';

// Guards
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

// Layouts
import { AppLayoutComponent } from './layouts/app/app.layout.component';

// Pages
import { InsightsPageComponent } from './pages/insights/insights-page.component';
import { IncidentsListPageComponent } from './pages/incidents/list-page/incidents-list-page.component';
import { IncidentDetailsPageComponent } from './pages/incidents/details-page/incident-details-page.component';
import { RimsPageComponent } from './pages/rims/rims.page.component';

// Resolvers
import { AnalyticsResolver } from './store/app/resolvers/analytics.resolver';
import { IncidentsResolver } from './store/app/resolvers/incidents.resolver';
import { HealthCheckPageComponent } from './pages/health-check/health-check-page.component';
import { AnalyticsDashboardPageComponent } from './pages/analytics/analytics-dashboard-page.component';
import { RimsPhaseInfosResolver } from './store/app/resolvers/rims-phase-infos.resolver';

export const routes: Routes = [
  { path: 'health-check', component: HealthCheckPageComponent, title: 'Health Check' },

  // Redirect route for normal access to the page
  { path: '', redirectTo: 'incidents', pathMatch: 'full' },

  // Authentication redirect route
  { path: 'auth', component: MsalRedirectComponent },

  // Private routes
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      // Incidents
      {
        path: 'incidents',
        component: IncidentsListPageComponent,
        title: 'Incidents Hub',
        data: {
          category: 'incidents-hub',
          icon: 'home',
          displayInMenu: true,
        },
        resolve: {
          incidents: IncidentsResolver,
        },
      },
      // Important: Angular matches the first route that fits. Create has to be before :incidentId
      {
        path: 'incidents/create',
        component: IncidentDetailsPageComponent,
        resolve: {
          rims: RimsPhaseInfosResolver,
        },
      },
      {
        path: 'incidents/:incidentId',
        component: IncidentDetailsPageComponent,
        resolve: {
          incidents: IncidentsResolver,
          rims: RimsPhaseInfosResolver,
        },
      },
      // Insights
      {
        path: 'insights',
        component: InsightsPageComponent,
        title: 'Incidents',
        data: {
          category: 'insights',
          icon: 'bar_chart',
          displayInMenu: true,
        },
      },
      {
        path: 'analytics',
        component: AnalyticsDashboardPageComponent,
        title: 'Analytics',
        data: {
          category: 'insights',
          icon: 'show_chart',
          displayInMenu: true,
        },
        resolve: {
          incidents: AnalyticsResolver,
        },
      },
      // Rims
      {
        path: 'rims/attributes',
        component: RimsPageComponent,
        title: 'Malicious',
        data: {
          category: 'rims',
          icon: 'playlist_add',
          displayInMenu: true,
        },
        resolve: {
          rims: RimsPhaseInfosResolver,
        },
      },
    ],
  },
];
